import { apiPost } from '@/utils/httpClient'
import { ConcordanceSearchRequest } from '@/pages/Document/Search/ConcordanceSearchModels'

export const concordanceSearchApi = {
    search(request: ConcordanceSearchRequest) {
        return apiPost('concordancesearch/search', request);
    }
}